export default __webpack_public_path__ + "static/media/junk0.19545c98.svg";